import { Button, Stack, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

const ContactBlock = () => {
  return (
    <Stack
      data-gtm-click-section='Do you need help finding the right training for you?'
      sx={{ width: '100%', alignItems: 'center', gap: 2, background: '#333333', paddingY: 4, borderRadius: 2 }}
    >
      <Typography variant='h4'>
        <FormattedMessage id='education.needHelp' />
      </Typography>
      <Button
        data-gtm-click-subsection2='primary-cta'
        component={Link}
        to='/sales'
        variant='contained'
        sx={{ width: 'fit-content' }}
      >
        <FormattedMessage id='common.contactUs' />
      </Button>
    </Stack>
  )
}

export default ContactBlock
